import styled from "@emotion/styled"
import IconArrow from '../../../../assets/svg/comp-button.svg'

export const MyPromotions = {
    block: styled.section`
        padding: 77px 0 157px;
        width: 100%;

        .react-multi-carousel {
            &-dot-list {
                @media (min-width: 769px) {
                    display: none;
                }
                counter-reset: item;
                bottom: -70px;
                justify-content: left;
    
                button {
                    background-color: transparent;
                    counter-increment: item;
                    font-family: 'Shell Book';
                    appearance: none;
                    border: none;
                    color: #3B3B3B;
                    font-size: 12px;
                    width: auto;
                    height: auto;

                    ::before {
                        font-family: 'Shell Heavy';
                        content: counter(item, decimal-leading-zero);
                    }
                }

            }
            
            &-dot--active{
                button {
                    color: #DD1D21;
                }
            }
        }
        
        .react-multiple-carousel__arrow {
            &--left,
            &--right {
                background: url(${IconArrow}) no-repeat;
                background-size: contain;
                border-radius: 0;
                bottom: -80px;
                height: 48px;
                width: 48px;

                ::before {
                    display: none;
                }
            }

            &--left {
                left: initial;
                right: 0px;
                transform: rotate(180deg) scale(1);

                &:hover {
                    transform: rotate(180deg) scale(1.2);
                }
            }
            
            &--right {
                transform: scale(1);
                right: -65px;

                &:hover {
                    transform: scale(1.2);
                }
            }
        }

        @media (max-width: 1599px) {
            .react-multiple-carousel__arrow {
                &--left {
                    right: 60px;
                }
                
                &--right {
                    right: 0;
                }
            }
        }

        @media (max-width: 1023px) {
            .react-multiple-carousel__arrow {
                &--left,
                &--right {
                    bottom: -80px;
                    height: 44px;
                    width: 44px;

                    ::before {
                        display: none;
                    }
                }

                &--left {
                    right: 50px;
                }
                
                &--right {
                    right: 0px;
                }
            }
        }

        .react-multi-carousel-list {
            overflow: visible;
        }
    `,

    wrapper: styled.div`
        max-width: 1480px;
        margin: 0 auto;
        padding: 0 20px;
    `
}